import { create } from 'zustand';

export type CurrencyCode = 'USD' | 'COP' | 'MXN';

const CURRENCY_STORAGE_KEY = 'stonehartden-currency';
const DEFAULT_CURRENCY: CurrencyCode = 'COP';

function getStoredCurrency(): CurrencyCode {
  if (typeof window === 'undefined') return DEFAULT_CURRENCY;
  const stored = localStorage.getItem(CURRENCY_STORAGE_KEY);
  if (stored === 'USD' || stored === 'COP' || stored === 'MXN') return stored;
  return DEFAULT_CURRENCY;
}

interface SettingsState {
  currency: CurrencyCode;
  setCurrency: (currency: CurrencyCode) => void;
  initialize: () => void;
}

export const useSettingsStore = create<SettingsState>((set) => ({
  currency: getStoredCurrency(),

  setCurrency: (currency: CurrencyCode) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(CURRENCY_STORAGE_KEY, currency);
    }
    set({ currency });
  },

  /** v1 Colombia: siempre COP (persistencia para v2). */
  initialize: () => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(CURRENCY_STORAGE_KEY, DEFAULT_CURRENCY);
    }
    set({ currency: DEFAULT_CURRENCY });
  },
}));
